/**
 * media query module
 * @module twt.media-query
 */

const queries = {
  xs: 'only screen',
  s: 'only screen and (min-width: 48em)',
  m: 'only screen and (min-width: 64em)',
  l: 'only screen and (min-width: 73.125em)',
};

let current = null;

/**
 * @return {void}
 */
function getCurrentSize() {
  let size = null;

  for (let i = 0; i < Object.keys(queries).length; i += 1) {
    if (window.matchMedia(queries[Object.keys(queries)[i]]).matches) {
      size = Object.keys(queries)[i];
    }
  }

  return size;
}

/**
 * @return {void}
 */
function registerEventListener() {
  window.addEventListener('resize', () => {
    const newSize = getCurrentSize();
    const currentSize = current;

    if (currentSize !== null && newSize !== currentSize) {
      // Change the current media query
      current = newSize;

      const event = new CustomEvent('changed.twt.mediaQuery', {
        detail: {
          newSize,
          oldSize: currentSize,
        },
      });

      window.dispatchEvent(event);
    }
  });
}

/**
 * @return {void}
 */
function init() {
  registerEventListener();
}

export { init, getCurrentSize };



// WEBPACK FOOTER //
// ./assets/js/components/twt.media-query.js